import {createStore, applyMiddleware, compose} from 'redux';
import rootReducer from '../reducers';
import thunk from 'redux-thunk';

const composeEnhancers = compose;

export default function configureStore(){
    return createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(thunk), window.devToolsExtension ? window.devToolsExtension() : f => f)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js